const globals = {
  __typename: 'Globals',
  showModal: false
};

export default globals;
